import { Gear, Headset } from '@unified-checkout/design-system/icons/index';
import { NotificationSystem, Spinner } from 'apps/customer/src/components';

import { INNER_ROUTES } from 'apps/customer/src/constants';
import { DeviceContext } from 'apps/customer/src/context/device';
import { useCurrentNotification, useLiveChat } from 'apps/customer/src/hooks';
import { lazy, ReactNode, Suspense, useContext, useState } from 'react';
import { Link } from 'react-router-dom';

const MobileNavMenu = lazy(() =>
  import('apps/customer/src/components').then((module) => ({
    default: module.MobileNavMenu,
  }))
);

const SideMenu = lazy(() =>
  import('apps/customer/src/components').then((module) => ({
    default: module.SideMenu,
  }))
);

type InnerLayoutProps = {
  children: ReactNode;
};

const InnerLayout = ({ children }: InnerLayoutProps) => {
  const { isMobile } = useContext(DeviceContext);
  const { chatToggler } = useLiveChat();

  const [isSideMenuCollapsed, setIsSideMenuCollapsed] = useState(false);
  const { currentNotification, setCurrentNotification } =
    useCurrentNotification();

  const closeNotificationHandler = () => {
    setCurrentNotification(undefined);
  };

  return (
    <div className="flex h-full md:bg-gray-50 pt-[5.3125rem] md:pt-0">
      <div className="md:w-72">
        <Suspense
          fallback={
            <div className="flex items-center justify-center h-full">
              <Spinner />
            </div>
          }
        >
          {isMobile ? (
            <MobileNavMenu />
          ) : (
            <div className="flex">
              <SideMenu
                isSideMenuCollapsed={isSideMenuCollapsed}
                setIsSideMenuCollapsed={setIsSideMenuCollapsed}
              />
            </div>
          )}
        </Suspense>
      </div>
      <div className="w-full overflow-hidden">
        {!isMobile && (
          <nav className="flex h-20 justify-between border-b border-gray-200 items-center [&_path]:fill-gray-500 [&_button]:md:!py-4 px-8 bg-gray-50">
            <div className="flex items-center gap-6 w-fit ms-auto">
              <button onClick={chatToggler}>{Headset}</button>
              <Link to={INNER_ROUTES.SETTINGS}>{Gear}</Link>
            </div>
          </nav>
        )}
        <main className="flex flex-col h-full px-4 md:h-[calc(100%-5rem)] md:space-y-8 overflow-y-auto md:px-[2.9%] bg-white pt-6">
          {!isMobile && (
            <NotificationSystem
              currentNotification={currentNotification}
              onClose={closeNotificationHandler}
            />
          )}
          <div className="flex flex-col grow">{children && children}</div>
        </main>
      </div>
    </div>
  );
};

export default InnerLayout;
